
import { Modal } from "react-bootstrap";
import useQRCartSection from "./useQRCartSection";
import {
  getBarcode,
  getPrice,
  getSizeName,
  getStock,
  getProductId,
} from "./qrcart.helpers";

function QRCartSection({
  product,
  onCartAdded,
}) {
  const {
    sizes,

    selectedSizeId,
    selectedItem,
    selectedIndex,

    customQuantity,
    loadingId,
    wishlistLoadingId,

    activeCartButtons,
    activeWishlistButtons,

    quantities,

    customers,
    customerSearch,
    setCustomerSearch,

    showCustomerModal,
    setShowCustomerModal,

    selectedCustomer,
    hasAnyValidQuantity,

    handleQuantityChange,
    handleCustomQuantity,

    handleSelectSize,

    handleAddToCart,
    handleWishlist,

    handleCustomerSelect,
  } = useQRCartSection({
    product,
    onCartAdded,
  });


  if (!product) {
    return null;
  }


  return (
    <>
      <div className="qr-cart-section">

        {sizes.length > 0 ? (
          <div className="qr-product-sizes">

            {/* =========================================
                SIZE TABLE
            ========================================= */}

            <div className="qr-size-table-wrapper">

              <table className="qr-size-table">

                <thead>
                  <tr>
                    <th className="text-center">
                      Size
                    </th>

                    <th className="text-center">
                      Shape
                    </th>

                    <th className="text-right">
                      MRP ( ₹)
                    </th>

                    <th className="text-center">
                      Stock
                    </th>

                    <th
                      className="text-center"
                      width="150"
                    >
                      Ord. Qty
                    </th>
                  </tr>
                </thead>


                <tbody>

                  {sizes.map(
                    (item, index) => {
                      const productId =
                        getProductId(
                          item,
                          index
                        );

                      const stock =
                        getStock(item);

                      const normalQty =
                        Number(
                          quantities[
                            productId
                          ] ?? 0
                        );

                      const customValue =
                        customQuantity[
                          productId
                        ];

                      const isCustom =
                        customValue !==
                          undefined &&
                        customValue !==
                          null;

                      const isSelected =
                        String(
                          selectedSizeId
                        ) ===
                        String(
                          productId
                        );


                      return (
                        <tr
                          key={`${productId}-${index}`}
                          className={
                            isSelected
                              ? "qr-selected-size-row"
                              : ""
                          }
                          onClick={() =>
                            handleSelectSize(
                              item,
                              index
                            )
                          }
                        >

                          {/* SIZE */}

                          <td className="text-center">
                            <strong
                              className="qr-size-hover"
                              data-barcode={
                                getBarcode(
                                  item
                                ) || "-"
                              }
                            >
                              {getSizeName(
                                item
                              )}
                            </strong>
                          </td>


                          {/* SHAPE */}

                          <td className="text-center">
                            {item?.shape ||
                              "-"}
                          </td>


                          {/* PRICE */}

                          <td className="text-right">
                            {Number(
                              getPrice(
                                item
                              ) || 0
                            ).toLocaleString(
                              "en-IN"
                            )}
                          </td>


                          {/* STOCK */}

                          <td className="text-center">
                            <span
                              className={
                                stock > 0
                                  ? "stock-available"
                                  : "stock-out"
                              }
                            >
                              {stock}
                            </span>
                          </td>


                          {/* =================================
                              QUANTITY
                          ================================= */}

                          <td
                            className="text-center"
                            onClick={(e) =>
                              e.stopPropagation()
                            }
                          >

                            {stock <= 0 ? (

                              <span className="text-danger">
                                Out of stock
                              </span>

                            ) : isCustom ? (

                              <input
                                type="text"
                                inputMode="numeric"
                                autoFocus
                                className="form-control form-control-sm text-center select-List"
                                value={
                                  customValue ?? ""
                                }
                                onChange={(e) =>
                                  handleCustomQuantity(
                                    item,
                                    index,
                                    e.target.value
                                  )
                                }
                                onFocus={(e) =>
                                  e.target.select()
                                }
                                onKeyDown={(e) => {

                                  if (
                                    e.key ===
                                    "Enter"
                                  ) {
                                    e.currentTarget.blur();
                                  }

                                  if (
                                    e.key ===
                                    "Escape"
                                  ) {
                                    handleQuantityChange(
                                      item,
                                      index,
                                      0
                                    );
                                  }
                                }}
                              />

                            ) : (

                              <select
                                className="form-control form-control-sm text-center select-List"
                                value={
                                  normalQty
                                }
                                onChange={(e) => {

                                  const value =
                                    e.target.value;


                                  /* 10+ */

                                  if (
                                    value ===
                                    "10+"
                                  ) {
                                    handleCustomQuantity(
                                      item,
                                      index,
                                      "10"
                                    );

                                    return;
                                  }


                                  const qty =
                                    Number(
                                      value
                                    );

                                  handleQuantityChange(
                                    item,
                                    index,
                                    qty
                                  );
                                }}
                              >

                                <option value={0}>
                                  0
                                </option>


                                {Array.from(
                                  {
                                    length:
                                      Math.min(
                                        9,
                                        stock
                                      ),
                                  },
                                  (_, i) =>
                                    i + 1
                                ).map(
                                  (qty) => (
                                    <option
                                      key={qty}
                                      value={qty}
                                    >
                                      {qty}
                                    </option>
                                  )
                                )}


                                {stock >=
                                  10 && (
                                  <option value="10+">
                                    10+
                                  </option>
                                )}

                              </select>
                            )}

                          </td>

                        </tr>
                      );
                    }
                  )}

                </tbody>

              </table>

            </div>


            {/* =========================================
                ACTION BUTTONS
            ========================================= */}

            <div className="col-md-12 text-right">

              {selectedItem && (
                <>
                  {(() => {
                    const item =
                      selectedItem;

                    const productId =
                      getProductId(
                        item,
                        selectedIndex
                      );

                    const isCartLoading =
                      loadingId ===
                        productId ||
                      loadingId ===
                        "bulk";

                    const isWishlistLoading =
                      wishlistLoadingId ===
                      productId;

                    const isCartActive =
                      Boolean(
                        activeCartButtons[
                          productId
                        ]
                      );

                    const isWishlistActive =
                      Boolean(
                        activeWishlistButtons[
                          productId
                        ]
                      );

                    return (
                      <>

                        {/* WISHLIST */}

                        <button
                          type="button"
                          className={`btn btn-warning btn-lg mt-3 ${
                            isWishlistActive
                              ? "wishlist-active"
                              : ""
                          }`}
                          style={{
                            width: "40px",
                            fontSize: "19px",
                            fontWeight: 600,
                            height: "37px",
                            marginRight: "10px",
                            padding: "0px",
                            boxShadow:
                              "0 0 3px #0000007a",
                          }}
                          onClick={(e) => {
                            e.stopPropagation();

                            handleWishlist(
                              item
                            );
                          }}
                          disabled={
                            isWishlistLoading
                          }
                          title="Add to Wishlist"
                        >

                          {isWishlistLoading ? (
                            <span
                              className="spinner-border spinner-border-sm"
                              role="status"
                            />
                          ) : (
                            <i
                              className={`bi ${
                                isWishlistActive
                                  ? "bi-heart-fill"
                                  : "bi-heart"
                              }`}
                            />
                          )}

                        </button>


                        {/* ADD TO CART */}

                        <button
                          type="button"
                          className={`btn ${
                            isCartActive
                              ? "btn-warning"
                              : "btn-primary"
                          } btn-lg mt-3`}
                          style={{
                            width: "154px",
                            fontSize: "14px",
                            fontWeight: 600,
                            boxShadow:
                              "0 0 3px #0000007a",
                          }}
                          onClick={async (e) => {
                            e.stopPropagation();

                            await handleAddToCart();
                          }}
                          disabled={
                            isCartLoading ||
                            !hasAnyValidQuantity
                          }
                        >

                          {isCartLoading ? (
                            <span
                              className="spinner-border spinner-border-sm me-1"
                              role="status"
                            />
                          ) : (
                            <i className="bi bi-cart-plus me-1" />
                          )}

                          ADD TO CART

                        </button>

                      </>
                    );
                  })()}
                </>
              )}

            </div>

          </div>
        ) : (

          <div className="qr-product-error">
            <strong>
              Size information not available
            </strong>
          </div>

        )}

      </div>


      {/* ===============================================
          CUSTOMER MODAL
      =============================================== */}

      <Modal
        show={showCustomerModal}
        onHide={() =>
          setShowCustomerModal(false)
        }
        centered
      >

        <Modal.Header closeButton>
          <Modal.Title>
            Select Customer
          </Modal.Title>
        </Modal.Header>


        <Modal.Body>

          <div className="mb-3">

            <input
              type="text"
              className="form-control"
              placeholder="Search customer..."
              value={
                customerSearch
              }
              onChange={(e) =>
                setCustomerSearch(
                  e.target.value
                )
              }
            />

          </div>


          {customers.length > 0 ? (

            <div className="customer-list">

              {customers.map(
                (
                  customer,
                  index
                ) => {

                  const id =
                    customer?.id ??
                    customer?.customer_id;

                  const name =
                    customer?.name ??
                    customer?.customer_name ??
                    customer?.company_name ??
                    "Customer";

                  const isSelected =
                    Number(
                      selectedCustomer?.id ??
                      selectedCustomer?.customer_id
                    ) ===
                    Number(id);


                  return (
                    <button
                      type="button"
                      key={
                        String(id) ||
                        `customer-${index}`
                      }
                      className={`customer-list-item ${
                        isSelected
                          ? "active"
                          : ""
                      }`}
                      onClick={() =>
                        handleCustomerSelect(
                          customer
                        )
                      }
                    >

                      <div>

                        <strong>
                          {name}
                        </strong>


                        {customer?.email && (
                          <small>
                            {
                              customer.email
                            }
                          </small>
                        )}


                        {customer?.mobile && (
                          <small>
                            {
                              customer.mobile
                            }
                          </small>
                        )}

                      </div>

                    </button>
                  );
                }
              )}

            </div>

          ) : (

            <div className="text-center py-4">
              No customers found
            </div>

          )}

        </Modal.Body>

      </Modal>

    </>
  );
}
export default QRCartSection;
